"use strict"

export default function routes($stateProvider) {
  "ngInject"

  $stateProvider
    .state("mainmap.home.availability-pick", {
      url: "/availability/:categorytype/:accomtype/:startdate/:enddate/:shouldpick",
      component: "availabilitycheck",
      resolve: {
        campsiteinfo: function (campsitedata) {
          return campsitedata
        },
      },
    })
    .state("mainmap.home.availability-check-showing", {
      url: "/availability/check",
      component: "availabilitycheck",
      resolve: {
        campsiteinfo: function (campsitedata) {
          return campsitedata
        },
      },
    })
    .state("mainmap.home.availability", {
      // staytypeid is a query param (not a path segment) — GemaPark can return
      // multiple stayTypes sharing one categoryID, so the URL needs to disambiguate
      // (e.g. categoryID 1 has both Self Catering and Glamping). Query param keeps
      // backward compat with the path shape used before disambiguation mattered.
      url: "/availability/:categorytype/:accomtype/:startdate/:enddate?staytypeid",
      component: "availabilitycheck",
      resolve: {
        campsiteinfo: function (campsitedata) {
          return campsitedata
        },
      },
    })
    .state("mainmap.home.availability-with-occupancy", {
      url: "/availability/:categorytype/:accomtype/:startdate/:enddate/:numofadults/:numofchildren/:numofinfants?staytypeid",
      component: "availabilitycheck",
      resolve: {
        campsiteinfo: function (campsitedata) {
          return campsitedata
        },
      },
    })
}
